<template>
    <div class="go-in">
        <banner img="../assets/img/bgtop.jpg" title="走进" />
        <div class="section" v-if="web_view == 'web'">
            <div class="contactUs-img" >
                <img src="@/assets/img/contactUs/nav1.png" />
            </div>
            <div class="submit-box">
                <div class="submit-box-left">
                    <div class="submit-box-title">
                        <img src="@/assets/img/case/sanjiao.png" />
                        <span>联系我们 / Content us</span>  
                    </div>
                    <div class="submit-box-info">
                        <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                    </div>
                    <div class="submit-box-info">
                        <span class="label">华东运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                    </div>
                    <div class="submit-box-info">
                        <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                    </div>
                    <div class="submit-box-info">
                        <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                    </div>   
                    <div id="container" style="width:100%;height:287px;margin:auto"></div>       
                </div>
                <div class="submit-box-right">
                    <div class="submit-box-title">
                        <img src="@/assets/img/case/sanjiao.png" />
                        <span>申请加盟 / join in</span>  
                    </div>
                    <input class="custom-input2 w-460" placeholder="姓名" v-model="form.name"/>
                    <input class="custom-input2 w-460" placeholder="电话" v-model="form.mobile"/>
                    <!-- <input class="custom-input2 w-320" placeholder="请输入验证码" v-model="form.code"/>
                    <a class="yzm" v-if="isSend == '1'" @click="sendCode()">发送验证码</a>
                    <a class="yzm2" v-else>{{time}}秒后重新发送</a> -->
                    <!-- <input class="custom-input2 w-460" placeholder="地址" v-model="form.mobile"/> -->
                    <!-- <a class="yzm" @click="sendCode()">发送验证码</a> -->
                    <textarea class="custom-text w-460" placeholder="需求" v-model="form.content"/>
                    <a class="submit-btn2" @click="submit()">提交留言</a>
                </div>
            </div>
            <!-- <div class="contact-box">
                    <div class="contact-box-left">
                        <img class="contact-box-left-img" src="@/assets/img/index/code.jpg" />
                        <p class="contact-box-left-title">心诚养车</p>
                        <div class="contact-box-left-info">
                            <p class="contact-box-left-info-title">安徽心诚科技信息有限公司</p>
                            <div class="split-line"></div>
                            <div class="contact-box-left-info-long">
                                <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                            </div>
                            <div class="contact-box-left-info-short">
                                <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                            </div>
                            <div class="contact-box-left-info-long">
                                <span class="label">华东运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                            </div>
                            <div class="contact-box-left-info-short">
                                <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                            </div>
                        </div>
                    </div>
                    <div class="contact-box-right">
                        <input class="custom-input w-200" placeholder="姓名" v-model="form.name"/>
                        <input class="custom-input w-200" placeholder="电话" v-model="form.mobile"/>

                        <textarea class="custom-input w-500" placeholder="内容" v-model="form.content"/>
                        <a class="submit-btn" @click="submit()">提交留言</a>
                    </div>
                </div> -->
            <div class="contactUs-map-img" >
                <a class="look-more" @click="toPath('prodectSite')">点击查看全部云仓分布点</a>
            </div>
            
        </div>
        <div class="section-h5" v-if="web_view == 'h5'">
            <div class="contactUs-img-h5" >
                <img src="@/assets/img/contactUs/nav1.png" />
            </div>
            <div class="contact-box-h5">
                <div class="contact-box-left">
                    
                    <div class="contact-box-left-info">
                        <div class="contact-box-left-info-long">
                            <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                        </div>
                        <div class="contact-box-left-info-long">
                            <span class="label">运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                        </div>
                        <div class="contact-box-left-info-short">
                            <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                        </div>                        
                        <div class="contact-box-left-info-short">
                            <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                        </div>
                    </div>
                    <div class="contact-box-left-code">
                        <img class="contact-box-left-img" src="@/assets/img/index/code.jpg" />
                        <p class="contact-box-left-title">心诚养车</p>
                    </div>
                </div>
                <div class="contact-box-right">
                    <input class="custom-input w-200" style="margin-right:2%" placeholder="姓名" v-model="form.name"/>
                    <input class="custom-input w-200" placeholder="电话" v-model="form.mobile"/>
                  
                    <textarea class="custom-input w-500" placeholder="内容" v-model="form.content"/>
                    <a class="submit-btn" @click="submit()">提交留言</a>
                </div>
            </div>
            <div class="contactUs-map-img-h5" >
                <img style="width:100%" src="@/assets/img/contactUs/nav2.png" />
                <!-- <div id="container" style="width:100%;height:200px;margin:auto"></div> -->
                <a class="look-more-h5" @click="toPath('prodectSite')">点击查看全部云仓分布点</a>
            </div>
            
        </div>
    </div>
</template>

<script>
import Banner from "../components/Banner2";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    components: {
        Banner,
        swiper,
        swiperSlide,
    },
    data() {
        return {
            web_view:"", // 视图窗口模式 900px以下是手机，以上是PC
            timer:null,
            isSend:"1",
            time:60,
            form:{
                name:"",
                mobile:"",
                content:"",
                code:"",
            },
            mobile:"",
            loading: false,
            honorList: [],
            partnerImg: [],
            courseList: [],
            teamItem: [],
            swiperOption: {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            dialogTableVisible: false,
            dialogUrl: "",
            dialogTitle: "",
        };
    },
    mounted() {
        let that = this
        if(parseFloat(document.body.clientWidth) < 900){
            this.web_view = 'h5'
            console.log("this.web_view",this.web_view)
        }else{
            this.web_view = 'web'
            console.log("this.web_view",this.web_view)
        }
        window.addEventListener('resize', function() {// 变化后需要做的事
            if(parseFloat(document.body.clientWidth) < 900){
                this.web_view = 'h5'
                console.log("this.web_view",this.web_view)
            }else{
                this.web_view = 'web'
                console.log("this.web_view",this.web_view)
            }
            that.$forceUpdate()
        })
        setTimeout(function(){
            that.initMap()
        },600)
    },
    methods: {
        initMap(){
            console.log("加载地图")
            // 创建地图实例
            var map = new AMap.Map("container", {
                zoom: 16,
                center: [118.36417,31.27174],
                resizeEnable: true
            });
            console.log("加载地图",map)
            // 以 icon URL 的形式创建一个途经点
            var viaMarker = new AMap.Marker({
                position: new AMap.LngLat(118.36417,31.27174),
                // 将一张图片的地址设置为 icon
                icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png',
                // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
                offset: new AMap.Pixel(-13, -30)
            });

            // 创建一个 Icon
            var startIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(25, 34),
                // 图标的取图地址
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                // 图标所用图片大小
                imageSize: new AMap.Size(135, 40),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(-9, -3)
            });

            // 将 icon 传入 marker
            var startMarker = new AMap.Marker({
                position: new AMap.LngLat(118.36417,31.27174),
                icon: startIcon,
                offset: new AMap.Pixel(-13, -30)
            });

            // 创建一个 icon
            var endIcon = new AMap.Icon({
                size: new AMap.Size(25, 34),
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                imageSize: new AMap.Size(135, 40),
                imageOffset: new AMap.Pixel(-95, -3)
            });

            // 将 icon 传入 marker
            var endMarker = new AMap.Marker({
                position: new AMap.LngLat(118.36417,31.27174),
                icon: endIcon,
                offset: new AMap.Pixel(-13, -30)
            });

            // 将 markers 添加到地图
            map.add([endMarker]);
        },
        toPath(e){
            this.$router.push({ name: e });
        },
        sendCode(){
            let that = this
            if(this.form.mobile == ""){
                this.$message({
                    message: "请输入手机号码",
                    type: "warning"
                }); 
                return
            }
            this.$http
            .post("franchise_applications/send_code", {
                mobile:this.form.mobile
            })
            .then(response => {;
                if(response.data.code == 200){
                    this.$message({
                        message: "发送成功！",
                        type: "success"
                    });
                    this.isSend = '0'
                    this.timer = setInterval(function() {
                        // 判断剩余秒数
                        if (that.time == 0) {
                        // 清除定时器和复原按钮
                            clearInterval(that.timer);
                            that.isSend = '1'
                            that.time = 60
                        } else {
                            that.time--;
                        }
                    }, 1000);
                }else{
                    this.$message({
                        message: response.data.msg,
                        type: "warning"
                    });     
                }
                
            })
            .catch(e => {
                this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
                });
            });
        },
        submit(){
            this.$http
            .post("franchise_applications/store", this.form)
            .then(response => {;
                if(response.data.code == 200){
                    this.$message({
                        message: "提交成功！",
                        type: "success"
                    });
                }else{
                    this.$message({
                        message: response.data.msg,
                        type: "warning"
                    });     
                }
            })
            .catch(e => {
                this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
                });
            });
        },
    }
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}

.go-in {
    width: 100%;
    height: 100%;
    background-color: #333;
    position: relative;
    overflow: hidden;
    .section {
        width: 100%;
        &-content {
            width: 1240px;
            margin: 0 auto;
            background-color: #fff;

            .content-summary {
                //height: 500px;
                display: flex;
                justify-content: space-around;
                padding: 100px 0;
                .summary-left {
                    width: 600px;
                    .title {
                        font-size: 25px;
                        color: #e13834;
                    }
                    .eTitle {
                        font-size: 17px;
                        color: #e13834;
                        padding: 20px 0;
                    }
                    .content {
                        color: #14679f;
                        font-size: 14px;
                        text-indent: 25px;
                        line-height: 30px;
                    }
                }

                .summary-right {
                    width: 400px;
                    height: 310px;
                    border: 2px solid #1d42b9;
                    //animation: imgboxkey 4s infinite;
                    border-radius: 10px;
                    margin-top: 80px;
                    text-align: center;

                    img {
                        width: 360px;
                        height: 270px;
                        margin-top: 20px;
                        //animation: imgbo 4s infinite;
                    }
                }
            }

            //发展历程
            .content-course {
                padding: 50px 0;
                .course-time {
                    width: 1000px;
                    height: 400px;
                    margin: 20px auto;
                    .swiper-container {
                        height: 100%;
                    }
                    .time-show {
                        width: 700px;
                        height: 100%;
                        margin: 0 auto;
                        display: flex;
                        .time-show-item {
                            width: 350px;
                            height: 100%;
                            overflow: hidden;
                            display: flex;
                            flex-direction: column;

                            .item-top,
                            .item-bottom {
                                height: 190px;
                            }
                            .item-bottom {
                                // display: flex;
                                // align-content: center;
                                .item-bottom-content {
                                    background-color: #1667a0;
                                    margin: 20px 0;
                                    p {
                                        color: #fff;
                                        text-align: center;
                                        padding: 15px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            //企业文化
            .content-culture {
                height: 450px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                padding-left: 100px;
                background-color: #c2daeb;
                h3 {
                    color: #3c6088;
                    font-size: 26px;
                }
                p {
                    color: #3c6088;
                    font-size: 26px;
                    padding: 5px 0;
                }
                span {
                    font-weight: 400;
                    line-height: 36px;
                    font-size: 18px;
                    padding: 5px 0;
                }
            }

            //公司荣誉
            .content-honor {
                padding: 50px 0;
                .honor-show {
                    width: 1000px;
                    margin: 30px auto;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    align-content: flex-start;

                    li {
                        width: 220px;
                        height: 320px;
                        margin-left: 15px;
                        list-style: none;
                        border: 1px solid palegoldenrod;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                p {
                    text-align: center;
                    color: #3c6088;
                }
            }

            //团队风采
            .content-team {
                padding: 50px 100px;
                .swiper-img {
                    height: 400px;
                    background: no-repeat center;
                    background-size: cover;
                }
            }

            //合作伙伴
            .content-partner {
                padding: 50px 0;
                .partner-img {
                    width: 950px;
                    margin: 20px auto;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    li {
                        width: 107px;
                        height: 107px;
                        list-style: none;
                        margin: 10px 25px;

                        img {
                            width: 100%;
                            height: 100%;
                            border: 1px solid rgb(194, 218, 235);
                        }
                    }
                }
            }
        }
    }
}

@keyframes imgboxkey {
    0% {
        border: solid rgb(29, 66, 185) 2px;
    }
    40% {
        border: solid rgb(255, 255, 255) 2px;
    }
    60% {
        border: solid rgb(255, 255, 255) 2px;
    }
    100% {
        border: solid rgb(29, 66, 185) 2px;
    }
}

@keyframes imgbo {
    0% {
        transform: scale(1);
        box-shadow: 0px 0px 0px 0px #ababab;
    }
    50% {
        transform: scale(1.1);
        box-shadow: 0px 0px 10px 5px #ababab;
    }
    100% {
        transform: scale(1);
        box-shadow: 0px 0px 0px 0px #ababab;
    }
}
.el-divider--horizontal {
    margin: 1px 0;
}

.top {
    h3,
    p {
        text-align: center;
        color: #3c6088;
        font-weight: 400;
        padding: 10px 0;
    }
    h3 {
        font-size: 30px;
    }
    p {
        font-size: 20px;
    }
    .border {
        border-bottom: 1px solid #3c6088;
        width: 15%;
        margin: 0 auto;
    }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
    order: -1;
}
.order-top {
    order: 1;
}
.el-divider {
    background-color: red;
    height: 3px;
    .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
        border: 3px solid red;
    }
}
.el-divider-active {
    background-color: #3c6088;
}
.honor-big-img {
    width: 100%;
    height: 100%;
    z-index: 10;
    text-align: center;
    padding-bottom: 20px;
    padding: 5%;
    //background-color: #14679f;
    .el-dialog__wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;

        .el-dialog__body {
            overflow: hidden;
            img {
                width: 100%;
            }
        }
    }
}
.contact-box {
    width: 1200px;
    height: 520px;
    margin: auto;
    padding: 40px 0;
    box-sizing: border-box;
    .contact-box-left {
        width: 600px;
        height: 100%;
        float: left;
        box-sizing: border-box;
        .contact-box-left-img {
            width: 160px;
            height: 160px;
            margin-left: 220px;
        }
        .contact-box-left-title {
            font-size: 14px;
            color: #fff;
            width: 160px;
            text-align: center;
            margin-left: 220px;
            margin-bottom: 80px;
        }
        .contact-box-left-info {
            font-size: 12px;
            color: #fff;
            .contact-box-left-info-title {

            }
            .split-line {
                height: 2px;
                width: 580px;
                background: #fff;
                margin: 10px 0;
            }
            .contact-box-left-info-long {
                width: 380px;
                height: 24px;
                line-height: 24px;
                float: left;
                .label {
                    width: 90px;
                    display: inline-block;
                }
            }
            .contact-box-left-info-short {
                width: 220px;
                height: 24px;
                line-height: 24px;
                float: left;
                .label {
                    width: 72px;
                    display: inline-block;
                }
            }

        }
    }
    .contact-box-right {
        width: 600px;
        height: 100%;
        float: left;
        .w-200 {
            width: 280px;
        }
        .w-500 {
            width: 570px;
            height: 200px !important;
        }
        .yzm {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 16px;
            width: 120px;
            color: #f56c6c;
        }
        .yzm2 {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 14px;
            width: 120px;
            color: #f56c6c;
        }
        .custom-input {
            background: #fff;
            border: none;
            padding: 4px 8px;
            box-sizing: border-box;
            color: #333;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            margin-right: 20px;
            margin-bottom: 20px;
        }
        .submit-btn {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #f00f0f;
            text-align: center;
            font-size: 16px;
            width: 120px;
            color: #fff;
        }
    }
}
.contactUs-img {
    text-align: center;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 80px;
}
.contactUs-map-img {
    text-align: center;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 80px;
}
.look-more {
    width: 967px;
    display: inline-block;
    color: #333;
    background: #eee;
    height: 40px;
    line-height: 40px;
    margin-top: 20px;
    border-radius: 4px;
    cursor: pointer;
}


.go-in {
    width: 100%;
    height: 100%;
    background-color: #333;
    position: relative;
    overflow: hidden;
    .section-h5 {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        &-content {
            width: 100%;
            margin: 0 auto;
            background-color: #fff;

            .content-summary {
                //height: 500px;
                display: flex;
                justify-content: space-around;
                padding: 100px 0;
                .summary-left {
                    width: 600px;
                    .title {
                        font-size: 25px;
                        color: #e13834;
                    }
                    .eTitle {
                        font-size: 17px;
                        color: #e13834;
                        padding: 20px 0;
                    }
                    .content {
                        color: #14679f;
                        font-size: 14px;
                        text-indent: 25px;
                        line-height: 30px;
                    }
                }

                .summary-right {
                    width: 400px;
                    height: 310px;
                    border: 2px solid #1d42b9;
                    //animation: imgboxkey 4s infinite;
                    border-radius: 10px;
                    margin-top: 80px;
                    text-align: center;

                    img {
                        width: 360px;
                        height: 270px;
                        margin-top: 20px;
                        //animation: imgbo 4s infinite;
                    }
                }
            }

            //发展历程
            .content-course {
                padding: 50px 0;
                .course-time {
                    width: 1000px;
                    height: 400px;
                    margin: 20px auto;
                    .swiper-container {
                        height: 100%;
                    }
                    .time-show {
                        width: 700px;
                        height: 100%;
                        margin: 0 auto;
                        display: flex;
                        .time-show-item {
                            width: 350px;
                            height: 100%;
                            overflow: hidden;
                            display: flex;
                            flex-direction: column;

                            .item-top,
                            .item-bottom {
                                height: 190px;
                            }
                            .item-bottom {
                                // display: flex;
                                // align-content: center;
                                .item-bottom-content {
                                    background-color: #1667a0;
                                    margin: 20px 0;
                                    p {
                                        color: #fff;
                                        text-align: center;
                                        padding: 15px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            //企业文化
            .content-culture {
                height: 450px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                padding-left: 100px;
                background-color: #c2daeb;
                h3 {
                    color: #3c6088;
                    font-size: 26px;
                }
                p {
                    color: #3c6088;
                    font-size: 26px;
                    padding: 5px 0;
                }
                span {
                    font-weight: 400;
                    line-height: 36px;
                    font-size: 18px;
                    padding: 5px 0;
                }
            }

            //公司荣誉
            .content-honor {
                padding: 50px 0;
                .honor-show {
                    width: 1000px;
                    margin: 30px auto;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    align-content: flex-start;

                    li {
                        width: 220px;
                        height: 320px;
                        margin-left: 15px;
                        list-style: none;
                        border: 1px solid palegoldenrod;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                p {
                    text-align: center;
                    color: #3c6088;
                }
            }

            //团队风采
            .content-team {
                padding: 50px 100px;
                .swiper-img {
                    height: 400px;
                    background: no-repeat center;
                    background-size: cover;
                }
            }

            //合作伙伴
            .content-partner {
                padding: 50px 0;
                .partner-img {
                    width: 950px;
                    margin: 20px auto;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    li {
                        width: 107px;
                        height: 107px;
                        list-style: none;
                        margin: 10px 25px;

                        img {
                            width: 100%;
                            height: 100%;
                            border: 1px solid rgb(194, 218, 235);
                        }
                    }
                }
            }
        }
    }
}
.contactUs-img-h5 {
    text-align: center;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    img {
        width: 100px;
    }
}
.contactUs-map-img-h5 {
    text-align: center;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
}
.look-more-h5 {
    width: 100%;
    display: inline-block;
    color: #333;
    background: #eee;
    height: 36px;
    line-height: 36px;
    margin-top: 10px;
    border-radius: 4px;
    cursor: pointer;
}
.contact-box-h5 {
    width: 100%;
    height: 412px;
    margin: auto;
    box-sizing: border-box;
    .contact-box-left {
        width: 100%;
        float: left;
        box-sizing: border-box;
        .contact-box-left-code {
            float: right;
            width: 100px;
            .contact-box-left-img {
                width: 100px;
                height: 100px;
            }
            .contact-box-left-title {
                font-size: 14px;
                color: #fff;
                width: 100px;
                text-align: center;
            }
        }
        
        .contact-box-left-info {
            float: left;
            width: calc(100% - 100px);
            font-size: 12px;
            color: #fff;
            .contact-box-left-info-title {

            }
            .split-line {
                height: 2px;
                
                width: 580px;
                background: #fff;
                margin: 10px 0;
            }
            .contact-box-left-info-long {
                width: 100%;
                line-height: 20px;
                float: left;
                .label {
                    float: left;
                    width: 60px;
                    display: inline-block;
                }
                .value {
                    float: left;
                    width: calc(100% - 60px);
                    display: inline-block;
                }
            }
            .contact-box-left-info-short {
                 width: 100%;
                line-height: 20px;
                float: left;
                .label {
                    float: left;
                    width: 60px;
                    display: inline-block;
                }
                .value {
                    float: left;
                    width: calc(100% - 60px);
                    display: inline-block;
                }
            }

        }
    }
    .contact-box-right {
        width: 100%;
        float: left;
        box-sizing: border-box;
        .w-200 {
            width: 49%;        
        }
        .w-500 {
            width: 100%;
            height: 200px !important;
        }
        .yzm {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 16px;
            width: 120px;
            color: #f56c6c;
        }
        .yzm2 {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 14px;
            width: 120px;
            color: #f56c6c;
        }
        .custom-input {
            background: #e4e7edd4;
            border: none;
            padding: 4px 8px;
            box-sizing: border-box;
            color: #333;
            height: 32px;
            line-height: 32px;
            font-size: 12px;
            margin-bottom: 10px;
            float: left;
        }
        .submit-btn {
            height: 36px;
            line-height: 36px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #f00f0f;
            text-align: center;
            font-size: 14px;
            width: 100%;
            color: #fff;
        }
    }
}

.submit-box {
    width: 960px;
    height: 454px;
    margin: auto;
    margin-top: 0px;
    .submit-box-left {
        float: left;
        width: 470px;
        margin-right: 10px;
        .submit-box-info {
            color: #fff;
            text-align: left;
            font-size: 14px;
            margin-bottom: 15px;
        }
        .map-img {
            width: 470px;
            margin-top: 36px;
        }
    }
    .submit-box-right {
        float: left;
        width: 470px;
        margin-left: 10px;
    }
}
.custom-input2 {
    background: #333;
    border: 1px solid #fff;
    border-radius: 4px;
    padding: 4px 8px;
    box-sizing: border-box;
    color: #fff;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    margin-right: 20px;
    margin-bottom: 12px;
}
.custom-text {
    background: #333;
    border: 1px solid #fff;
    border-radius: 4px;
    padding: 4px 8px;
    box-sizing: border-box;
    color: #fff;
    height: 224px;
    line-height: 50px;
    font-size: 16px;
    margin-right: 20px;
    margin-bottom: 20px;
}
.submit-btn2 {
    height: 50px;
    line-height: 50px;
    display: inline-block;
    box-sizing: border-box;
    background: #ee1919;
    text-align: center;
    font-size: 16px;
    width: 460px;
    color: #fff;
    position: relative;
}
.submit-box-title {
    color: #fff;
    height: 60px;
    img {
        float: left;
        height: 24px;
        width: 16px;
        margin-right: 10px;
    }
    span {
        color: #fff;
        float: left;
    }
}
.w-460 {
    width: 460px;
}
</style>
